import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import GestionOrigenes from './GestionOrigenes';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import { Checkbox } from '@mui/material';
function Origenes() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [origenes, setOrigenes] = useState([]);
    const [editingOrigen, setEditingOrigen] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [origenToDelete, setOrigenToDelete] = useState(null);

    const { user } = useUser();
    // Función para cargar los orígenes
    const fetchOrigenes = async () => {
        try {
            const response = await fetch(`${server}/MgOrigenes`);
            const data = await response.json();
            setOrigenes(data.$values);
        } catch (error) {
            console.error('Error al cargar los orígenes:', error);
        }
    };

    // Use effect para cargar los orígenes al montar el componente
    useEffect(() => {
        fetchOrigenes();
    }, []);

    // Actualiza la lista de orígenes tras una modificación
    const handleNewOrigenes = () => {
        fetchOrigenes();
        setEditingOrigen(null);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (origen) => {
        setOrigenToDelete(origen);
        setOpenDialog(true);
    };

    const handleEditOrigen = (origen) => {
        setEditingOrigen({ ...origen }); // ← Esto crea un nuevo objeto y forza la actualización
    };


    const handleCloseDialog = () => {
        setOpenDialog(false);
        setOrigenToDelete(null);
    };

    const handleDeleteOrigen = async () => {
        if (origenToDelete) {
            const username = '' + user.codigoUsuario + '/';
            try {
                const response = await fetch(`${server}/MgOrigenes/${origenToDelete.idOrigen}/${username}`, {
                    method: 'DELETE'
                });
                console.log(response);
                fetchOrigenes();
                handleCloseDialog();
                    Swal.fire({
                        icon: 'success',
                        title: '¡Éxito!',
                        text: 'Origen eliminado con éxito.',
                        timer: 2000,
                        showConfirmButton: false
                    });
                // if (response.ok) {
                //     handleCloseDialog();
                //     fetchOrigenes();
                //     Swal.fire({
                //         icon: 'success',
                //         title: '¡Éxito!',
                //         text: 'Origen eliminado con éxito.',
                //         timer: 2000,
                //         showConfirmButton: false
                //     });
                //     // alert('Origen eliminado con éxito');
                // } else {
                //     Swal.fire({
                //         icon: 'error',
                //         title: '¡Error!',
                //         text: 'Error al eliminar el origen.',
                //         timer: 2500,
                //         showConfirmButton: false
                //     });
                // }
            } catch (error) {
                console.error('Error al eliminar el origen:', error);
                alert('Error al eliminar el origen');
            }
        }
    };

    const filteredOrigenes = origenes.filter(origen =>
        origen.descripcion?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        origen.alias?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        origen.rtn?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title">
                    <h2>Gestión de Orígenes</h2>
                </div>
                <div className="x_content">

                    <br />
                    {/* <div className="row"> */}

                    {/* <div className="col-md-7 col-sm-4 offset-md-2"> */}
                    <GestionOrigenes handleNewOrigenes={handleNewOrigenes} origen={editingOrigen} />
                    {/* </div> */}

                    {/* <div className="col-md-7 col-sm-4 offset-md-2"> */}
                    <div className="ln_solid" />
                    <br />
                    <h2>Orígenes Existentes</h2>
                    <TextField
                        variant="outlined"
                        label="Buscar origen"
                        fullWidth
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{ marginBottom: '20px' }}
                    />
                    <div className="table-responsive">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right">Acciones</TableCell>
                                        <TableCell>Empresa</TableCell>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell>Alias</TableCell>
                                        <TableCell>RTN</TableCell>
                                        <TableCell>Celular</TableCell>
                                        <TableCell>Correo</TableCell>
                                        <TableCell>Porcentaje Descuento</TableCell>
                                        <TableCell>Credito Autorizado</TableCell>
                                        <TableCell>Dias Credito</TableCell>
                                        <TableCell>Aseguradora</TableCell>
                                        <TableCell>Porcentaje Copago</TableCell>
                                        <TableCell>Cuenta Contable</TableCell>
                                        <TableCell>Outsourcing</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredOrigenes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((origen) => (
                                        <TableRow key={origen.id}>
                                            <TableCell align="right">
                                                <Button onClick={() => handleEditOrigen(origen)} color="primary" disabled={!tienePermiso('Editar Origen')}>Editar</Button>
                                                <Button onClick={() => handleOpenDialog(origen)} color="secondary" disabled={!tienePermiso('Eliminar Origen')}>Eliminar</Button>
                                            </TableCell>
                                            <TableCell>
                                                <Checkbox checked={!!origen.empresa} disabled />
                                            </TableCell>
                                            <TableCell>{origen.descripcion}</TableCell>
                                            <TableCell>{origen.alias}</TableCell>
                                            <TableCell>{origen.rtn}</TableCell>
                                            <TableCell>{origen.celular}</TableCell>
                                            <TableCell>{origen.correo}</TableCell>
                                            <TableCell>{origen.porcentajeDescuento}</TableCell>
                                            <TableCell>
                                                <Checkbox checked={!!origen.creditoAutorizado} disabled />
                                            </TableCell>
                                            <TableCell>{origen.diasCredito}</TableCell>
                                            <TableCell>
                                                <Checkbox checked={!!origen.aseguradora} disabled />
                                            </TableCell>
                                            <TableCell>{origen.porcentajeCopago}</TableCell>
                                            <TableCell>{origen.idCuentaContable}</TableCell>
                                            <TableCell>{origen.outsourcing}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredOrigenes.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                            />
                        </TableContainer>
                        <Dialog
                            open={openDialog}
                            onClose={handleCloseDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    ¿Estás seguro de que deseas eliminar el origen seleccionado?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                <Button onClick={handleDeleteOrigen} color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                    {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default Origenes;
